import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classname';
import renderViewsState from '../../shared/render-views-state';
import { Link } from 'react-router';
import { baseUrl } from '../../../config/route-entry-point';

import StreamsTable from '../components/table/streams-list';
import StreamsSearch from '../components/filter/search-form';
import LinkBuilder from '../components/popups/link-builder';
import SplitSessions from '../components/popups/split-sessions';
import Filters from '../../shared/filters/main';
import Calendar from '../../shared/calendar/main';

import '../../../../shared/modules/streams/list/main.less';
lessRequire('modules/streams/list/main.less');

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = renderViewsState(props => {
	const { intl } = props;

	return (
		<div className="streams-wrap container">
			{!isRocket &&
			!!props.campaignsWithoutConversions.length &&
			!props.isToggleLoading &&
			!props.showArchived && (
				<div className="streams__problems-pop-up">
					<h4>{intl('Потоки без конверсий')}</h4>
					<h5>{intl('По указанным потокам не было лидов')}</h5>
					<div className="streams__problems-pop-up-body">
						{props.campaignsWithoutConversions.map(row => (
							<div key={row.months}>
								<h5>{intl('%d мес.', row.months)}</h5>
								<span>{row.ids.join(', ')}</span>
							</div>
						))}
					</div>
					<div className="streams__problems-pop-up-buttons">
						<a className="button yellow-btn" href="#" onClick={ev => {
							ev.preventDefault();
							props.closeCampaignsWithoutConversionsPopUp(true);
						}}>{intl('Понятно, не показывать')}</a>
						<a className="button yellow-btn gray-btn" href="#" onClick={ev => {
							ev.preventDefault();
							props.closeCampaignsWithoutConversionsPopUp(false);
						}}>{intl('Напомнить позже')}</a>
					</div>
					<div className="streams__problems-pop-up-buttons">
						<a className="button yellow-btn gray-btn" href="#" onClick={ev => {
							ev.preventDefault();
							props.removeExpiredCampaigns();
						}}>{intl('Архивировать потоки')}</a>
					</div>
				</div>
			)}
			<div className="content-container">
				<table className="top-form">
					<tbody>
						<tr>
							<td width={1}>
								<h2 className="font-proxima-nova-bold">{intl('Мои потоки')}</h2>
							</td>
							<td>
								<div className="element__field">
									<StreamsSearch {...props} />
								</div>
							</td>
							<td width={1}>
								<div className="streams-wrap__buttons">
									<Link to={baseUrl('campaigns/new/')}
										className="button yellow-btn create-streams font-proxima-nova-semibold"
									>
										{intl('Добавить поток')}
									</Link>
									<Link to={baseUrl('campaigns/global-postback/')}
										className="button white-bg yellow-border global-postback font-proxima-nova-semibold"
									>
										{intl('Глобальный постбэк')}
									</Link>
								</div>
							</td>
						</tr>
					</tbody>
				</table>

				<div className="streams-wrap__filters">
					<div className="streams-wrap__filters-items">
						<Filters {...props} />
					</div>
					{!isRocket && (
						<div className="streams-wrap__filters-archived" onClick={props.toggleShowArchived}>
							<div className={cn(
								'streams__archived-filter-item icon-green',
								{ 'streams__archived-filter-item_active': !props.showArchived }
							)}>{intl('Активные')}</div>
							<div className={cn(
								'streams__archived-filter-item icon-cancel',
								{ 'streams__archived-filter-item_active': props.showArchived }
							)}>{intl('Архив')}</div>
						</div>
					)}
					<div className="streams-wrap__filters-calendar">
						<Calendar
							{...props.calendar}
							onInit={props.calendarInit}
							onToggle={props.calendarToggle}
							onChange={props.calendarChange}
							onApply={props.calendarApply}
							intl={props.intl}
						/>
					</div>

					<div className="streams-wrap__filters-actions">
						<button className="reset-btn" onClick={() => props.clearAllFilters()}/>
					</div>
				</div>

				{isRocket && (
					<div className="streams-wrap__filters">
						<div className="streams-wrap__filters-archived" onClick={props.toggleShowArchived}>
							<div className={cn(
								'streams__archived-filter-item icon-green',
								{ 'streams__archived-filter-item_active': !props.showArchived }
							)}>{intl('Активные')}</div>
							<div className={cn(
								'streams__archived-filter-item icon-cancel',
								{ 'streams__archived-filter-item_active': props.showArchived }
							)}>{intl('Архив')}</div>
						</div>
					</div>
				)}

				{ <StreamsTable
					data={ props.dataTable }
					paginationParams={ props.paginationParams }
					showMore={props.showMore}
					onDeleteItem={props.deleteItem}
					fetchCampaignsBatch={props.fetchCampaignsBatch}
					toggleLinkBuilder={props.toggleLinkBuilder}
					cloneCampaign={props.cloneCampaign}
					toggleSplitSessions={props.toggleSplitSessions}
					splitSessions={props.splitSessions}
					intl={intl}
					highlightedRowId={props.highlightedRowId}
					showArchived={props.showArchived}
				/>
				}

				{ <LinkBuilder
					shouldShow={props.linkBuilder.shouldShow}
					links={props.linkBuilder.links}
					onClose={props.toggleLinkBuilder}
					onChangeSids={props.changeSid}
					geoOptions={props.linkBuilder.geoOptions}
					sendTestConversion={props.sendTestConversion}
					shouldShowTestSuccess={props.linkBuilder.shouldShowTestSuccess}
					shouldDisableCountrySelect={props.linkBuilder.shouldDisableCountrySelect}
					intl={intl}
				/>
				}

				{ <SplitSessions data={props.splitSessions} toggleSplitSessions={props.toggleSplitSessions} intl={intl}/> }
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		paginationParams: selectors.getPaginationParams(state),
		dataTable: selectors.getTableData(state),
		linkBuilder: selectors.getLinkBuilderData(state),
		splitSessions: selectors.getSplitSessionsData(state),
		intl: selectors.getIntl(state),
		showArchived: selectors.getShowArchived(state),
		filters: selectors.getFilters(state),
		appliedFilters: selectors.getAppliedFilters(state),
		calendar: selectors.getCalendar(state),
		error: selectors.getError(state),
		highlightedRowId: selectors.getHighlightedRowId(state),
		isToggleLoading: selectors.getIsToggleLoader(state),
		campaignsWithoutConversions: selectors.getCampaignsWithoutConversions(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/list/main.js